import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async realizarLogout(api) {       
    let parametros = {operacao: 'realizarLogout'}
    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RLogout.js